import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import { LoginPage } from "./components/LoginPage";
import { MainStudio } from "./components/MainStudio";
import { Header } from "./components/Header";   // ✅ ADD THIS

function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const savedUser = localStorage.getItem("user");
    if (savedUser) {
      setUser(JSON.parse(savedUser));
    }
  }, []);

  const handleLogin = (userData) => {
    localStorage.setItem("user", JSON.stringify(userData));
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem("user");
    setUser(null);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 to-[#1a074f] text-white font-sans">
      
      <Router>
        <Routes>

          {/* LOGIN ROUTE */}
          <Route
            path="/login"
            element={
              user ? <Navigate to="/dashboard" /> : <LoginPage onLogin={handleLogin} />
            }
          />

          {/* DASHBOARD ROUTE */}
          <Route
            path="/dashboard"
            element={
              user ? (
                <div>
                  <Header user={user} onLogout={handleLogout} /> {/* ✅ SHOW ONLY AFTER LOGIN */}
                  <MainStudio user={user} />
                </div>
              ) : (
                <Navigate to="/login" />
              )
            }
          />

          {/* DEFAULT ROUTE */}
          <Route
            path="*"
            element={
              user ? <Navigate to="/dashboard" /> : <Navigate to="/login" />
            }
          />

        </Routes>
      </Router>
    </div>
  );
}

export default App;
